module.exports = __webpack_public_path__ + "img/L_1C.15786fec.png";